import type { Action } from "@core/features/actions";
import { ProgramPhaseActionItem } from "./ProgramPhaseActionItem";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";

type Props = {
  action: Action;
  disabled: boolean;
};

export function ProgramPhaseActionItemContainer({ action, disabled }: Props) {
  const userTimezoneOption = useUserTimezoneOption();

  if (!userTimezoneOption) {
    return null;
  }

  return (
    <ProgramPhaseActionItem
      action={action}
      disabled={disabled}
      userTimezoneOption={userTimezoneOption}
    />
  );
}

export default ProgramPhaseActionItemContainer;

